var startsWith = require('../string/virtual/starts-with');

var StringPrototype = String.prototype;

module.exports = function (it) {
  var own = it.startsWith;
  return typeof it === 'string' || it === StringPrototype
    || (it instanceof String && own === StringPrototype.startsWith) ? startsWith : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/starts-with.js
// module id = 994
// module chunks = 0